import Client from 'config/axios';

export const FacebookToken = async (token: string, isFanpage: boolean) => {
  const endpoint = isFanpage
    ? 'get-authentication-url/fanpage'
    : 'get-authentication-url/facebook';
  return await Client.get(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
